class Extranet.Common.Utilities.Mixin

  @extends: (view, mixin) ->
    Object.assign view.prototype, mixin
